// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs/tabs.component.scss
// module id = 535
// module chunks = 0